import React from 'react';
import { Outlet } from 'react-router-dom';

const InternationalRouter: React.FC = () => {
  return <Outlet />;
};

export default InternationalRouter;
